import { Component, OnInit } from '@angular/core';
import {HttpService} from '../_service/http.service';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css']
})
export class IntegrationComponent implements OnInit {

  period: number;
  integrations: any;
  limitAmount: number;
  organizationId: any;
  isSuccessIntegration: number;
  methods = [];
  chosenMethod: string;
  fileUrl: string;
  organizations = [];
  static INTEGRATIONS_BLOCK_ID = "integrations-block";

  constructor(private http: HttpService) {
    this.period = 1;
    this.limitAmount = 20;
    this.isSuccessIntegration = -1;
  }

  ngOnInit() {
    this.getIntegrationSelectOptions().then((data) => {
      this.chosenMethod = this.methods[0];
      this.getIntegrations();
    });
  }

  setPeriod(value) {
    this.period = value;
    this.getIntegrations();
  }

  async getIntegrations() {

    const sb = [];
    sb.push("rest/getIntegrations");
    sb.push("?period=" + this.period);
    sb.push("&method=");
    sb.push(this.chosenMethod);
    sb.push("&limitAmount=");
    sb.push(this.limitAmount);
    sb.push("&success=");
    sb.push(this.isSuccessIntegration);
    sb.push("&organizationId=");
    sb.push(this.organizationId);

    console.log("Get integrations: period = " + this.period + ", method = " + this.chosenMethod
      + ", limitAmount = " + this.limitAmount + ", isSuccessIntegration = " + this.isSuccessIntegration
      + ", organizationId = " + this.organizationId);

    await this.http.getDataWithLocalAuth(sb.join("")).then(
      (data) => {
        console.log("getIntegrations data: ", data);
        this.integrations = data;
        this.initIntegrations();
      }, (error) => {
        console.warn("getIntegrations error: ", error);

      }
    )
  }

  async getFile(integrationFileId, intStartDate, intMethod, organizationName) {
    const sb = [];
    sb.push("rest/getIntegrationFile");
    sb.push("?integrationFileId=" + integrationFileId);
    console.log("Get getIntegrationFile: integrationFileId = " + integrationFileId );

    await this.http.getRawDataWithLocalAuth(sb.join(""), IntegrationComponent.INTEGRATIONS_BLOCK_ID)
      .then(
      (data) => {
        console.log("getIntegrationFile data: ", data);
        this.downloadFile(data._body, intStartDate, intMethod, organizationName);
      }, (error) => {
        console.warn("getIntegrationFile error: ", error);

      }
    )
  }

  async getIntegrationSelectOptions() {

    const sb = [];
    sb.push("rest/getIntegrationSelectOptions?");

    await this.http.getDataWithLocalAuth(sb.join(), IntegrationComponent.INTEGRATIONS_BLOCK_ID)
      .then((data) => {
          console.log("Get getIntegrationMethods data: ", data);
          this.methods = data.methods;
          this.organizations = data.organizations;
          if(this.organizations != null || this.organizations.length > 0) {
            this.organizationId = this.organizations[0].id;
          }

        }, (error) => {
          console.warn("Get getIntegrationMethods error: ", error);
        }
      )
  }

  downloadFile(data: Response, intStartDate, intMethod, organizationName){

    // @ts-ignore
    let blob = new Blob([data], { type: 'text/plain; charset=utf-8' });

    let a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = organizationName + "_" + ( intMethod == null ? "" : intMethod ) + '_'
      + new Date(intStartDate).toLocaleString("ru-RU", { year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) + '.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  initIntegrations() {
    this.integrations = this.integrations
      .map(i => { i.isErrorOpened = i.isTitleOpened = false; return i});
    console.log("init integratons: ", this.integrations);
  }

  chooseMethod(methodName) {

    this.chosenMethod = methodName;
    console.log("Chosen method: ", this.chosenMethod);

    this.getIntegrations();
  }

  setLimitAmount(amount) {
    this.limitAmount = amount;
    console.log("Chosen amount limit: ", this.limitAmount);

    this.getIntegrations();
  }

  setOrganization(orgId) {
    this.organizationId = orgId;
    console.log("Chosen organization: ", this.organizationId);

    this.getIntegrations();
  }

  setSuccess(isSuccessIntegration) {
    this.isSuccessIntegration = isSuccessIntegration;
    console.log("Chosen isSuccessIntegration: ", this.isSuccessIntegration);

    this.getIntegrations();
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/integration/integration.component.ts